module.exports = __webpack_public_path__ + "img/taili4.18941371.jpg";